import FileViewer from './file-viewer'

export default FileViewer
